var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.point.geofence.type === 'POLYGON')?_c('GmapPolygon',{key:`geofence-polygon-${_vm.point.id}`,attrs:{"paths":_vm.polygon,"options":{
    strokeColor: '#033380',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#4c8df5',
    fillOpacity: 0.35,
    clickable: false,
  }}}):(_vm.point.geofence.type === 'CIRCLE')?_c('GmapCircle',{key:`geofence-circle-${_vm.point.id}`,attrs:{"visible":true,"center":{
    lat: _vm.point.lat,
    lng: _vm.point.lng,
  },"radius":_vm.point.geofence.radius || 100,"options":{
    strokeColor: '#033380',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#4c8df5',
    fillOpacity: 0.35,
    clickable: false,
  }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }